import { render, staticRenderFns } from "./LeaderBoardPanel.vue?vue&type=template&id=ee27fef8&lang=pug&"
import script from "./LeaderBoardPanel.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports